/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';

import { InlineNotification, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

const styles = {
  error: () => css`
    margin-top: var(--cds-spacing-400);
  `,
};

// isApplyOverrideDialog (required): false = deleteOverrideDialog
type Props = {
  isApplyOverrideDialog: boolean;
  errorDetails: string;
};

// Component for grade override error notifications
const ErrorNotification = ({ isApplyOverrideDialog, errorDetails }: Props) => {
  let errorText;
  let errorTitle;

  if (isApplyOverrideDialog) {
    errorText = _t('Something went wrong while applying grade override. Please try again.');
    errorTitle = _t('Unable to apply grade override.');
  } else {
    errorText = _t('Something went wrong while deleting grade override. Please try again.');
    errorTitle = _t('Unable to delete grade override.');
  }

  return errorText ? (
    <InlineNotification severity="error" title={errorTitle} css={styles.error}>
      <React.Fragment>
        {errorText}
        {config.environment === 'development' && (
          <Typography2 component="div" variant="bodySecondary">
            Details: {errorDetails}
          </Typography2>
        )}
      </React.Fragment>
    </InlineNotification>
  ) : null;
};

export default ErrorNotification;
